(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["viviero-color-reference"] && !Shopify.designMode) return;
  try {
    (function () {
  function update() {
    var context = document.querySelector('[data-viviero-color-reference]');
    var note = document.querySelector('#viviero-colors-v8 .vcp-reference-note');
    if (context && note) note.textContent = context.dataset.vivieroColorReference;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true }); else update();
  document.addEventListener('shopify:section:load', update);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["viviero-stand-size-picker"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  function init(root) {
    if (root.dataset.sizeReady) return;
    var native = root.querySelector('[data-viviero-size-native]');
    var radios = Array.from(native.querySelectorAll('input[data-variant-option-value]'));
    var pattern = /^([\d.]+)\s*[×x]\s*([\d.]+)["”″]\s*\|\s*([\d.]+)\s*[×x]\s*([\d.]+)\s*cm$/;
    var sizes = radios.map(function (input) {
      var match = input.value.trim().match(pattern);
      return match ? { input: input, width: match[1], height: match[2], widthCm: match[3], heightCm: match[4] } : null;
    });
    if (!sizes.length || sizes.some(function (size) { return !size; })) return;
    var controls = root.querySelector('[data-viviero-size-controls]');
    var width = root.querySelector('[data-viviero-width]');
    var height = root.querySelector('[data-viviero-height]');
    var status = root.querySelector('[data-viviero-size-selection]');
    var widths = Array.from(new Set(sizes.map(function (size) { return size.width; })));
    var pendingWidth = '';
    var lastNativeValue = '';
    var frame = 0;
    function label(inches, cm) { return inches + '" / ' + cm + ' cm'; }
    function selected() { return sizes.find(function (size) { return size.input.checked; }); }
    function options(select, values, value) {
      var existing = Array.from(select.options).map(function (option) { return [option.value, option.textContent, option.disabled]; });
      if (JSON.stringify(existing) !== JSON.stringify(values)) {
        select.replaceChildren.apply(select, values.map(function (entry) {
          var option = document.createElement('option');
          option.value = entry[0]; option.textContent = entry[1]; option.disabled = entry[2];
          return option;
        }));
      }
      select.value = value;
    }
    function sync() {
      frame = 0;
      var choice = selected();
      if (choice && choice.input.value !== lastNativeValue) {
        pendingWidth = ''; lastNativeValue = choice.input.value;
      }
      var chosenWidth = pendingWidth || (choice && choice.width) || widths[0];
      options(width, widths.map(function (w) {
        var group = sizes.filter(function (size) { return size.width === w; });
        return [w, label(w, group[0].widthCm), group.every(function (size) { return size.input.disabled; })];
      }), chosenWidth);
      var group = sizes.filter(function (size) { return size.width === chosenWidth; });
      var chosenHeight = !pendingWidth && choice && choice.width === chosenWidth ? choice.height : '';
      var heightOptions = [['', root.dataset.chooseHeight, true]].concat(group.map(function (size) {
        return [size.height, label(size.height, size.heightCm) + (size.input.disabled ? ' — ' + root.dataset.unavailable : ''), size.input.disabled];
      }));
      options(height, heightOptions, chosenHeight);
      status.textContent = pendingWidth ? root.dataset.chooseHeight : (choice ? choice.input.value : '');
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(sync); }
    width.addEventListener('change', function () {
      var choice = selected();
      var sameHeight = choice && sizes.find(function (size) { return size.width === width.value && size.height === choice.height && !size.input.disabled; });
      var firstAvailable = sizes.find(function (size) { return size.width === width.value && !size.input.disabled; });
      var target = sameHeight || firstAvailable;
      if (target) { pendingWidth = ''; target.input.click(); } else { pendingWidth = width.value; }
      schedule();
    });
    height.addEventListener('change', function () {
      var target = sizes.find(function (size) { return size.width === width.value && size.height === height.value; });
      if (target && !target.input.disabled) { pendingWidth = ''; target.input.click(); }
      schedule();
    });
    var form = root.closest('form');
    if (form) form.addEventListener('change', schedule);
    new MutationObserver(schedule).observe(native, { subtree: true, attributes: true, attributeFilter: ['disabled', 'checked', 'class', 'aria-disabled'] });
    window.addEventListener('pageshow', schedule);
    root.dataset.sizeReady = 'true';
    sync();
    native.hidden = true;
    controls.hidden = false;
  }
  function start() { document.querySelectorAll('[data-viviero-stand-size]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

})();
